export const POSITION_OPTIONS = [
  "Catcher",
  "First Baseman",
  "Outfield",
  "Pitcher",
  "Second Baseman",
  "Shortstop",
  "Third Baseman",
  "Utility",
];
